module.exports = __webpack_public_path__ + "img/love.d4955bac.gif";